export class SessionStorage {
    constructor($window) {
        this.$window = $window;
    }

    getItem(key) {
        var valueString = this.$window.sessionStorage.getItem(key);
        return angular.fromJson(valueString);
    }

    setItem(key, value) {
        var valueString = angular.toJson(value);
        this.$window.sessionStorage.setItem(key, valueString);
    }
}

SessionStorage.$inject = ['$window'];